// extracted by mini-css-extract-plugin
export default {"root":"VerificationCodeView_root__e5ZFd","formWrapper":"VerificationCodeView_formWrapper__jv3zf","inputWrapper":"VerificationCodeView_inputWrapper__+w7pD"};